//@flow

import {useSelector} from 'react-redux';
import {actions as tierRestrictionActions} from '../duck';
import type {RootState} from '../../';
import {useActions} from '../../../utils/globalStore';
import {useCallback} from 'react';

const selectTierRestriction = (state: RootState) => state.tierRestriction;

export function useTierRestriction() {
  const {tierRestrictionModalOpen} = useSelector(selectTierRestriction);

  return {
    tierRestrictionModalOpen,
  };
}

export function useTierRestrictionActions() {
  const actions = useActions(tierRestrictionActions);

  const showTierRestrictionModal = useCallback(() => {
    actions.openTierRestrictionModal(true);
  }, [actions]);

  const hideTierRestrictionModal = useCallback(() => {
    actions.closeTierRestrictionModal(false);
  }, [actions]);

  return {
    showTierRestrictionModal,
    hideTierRestrictionModal,
  };
}
